import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n	width: 100%;\n	max-width: 1400px;\n	margin: 24px auto;\n	",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n	width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    	padding: 0 80px;\n  	"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n	width: 100%;\n	max-width: 500px;\n	margin: 16px auto;\n	padding: 0 24px;\n	",
        "\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n	width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n      margin-bottom: 24px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n	margin-bottom: 16px;\n	",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n	margin: 8px 0;\n	display: flex;\n	justify-content: flex-start;\n	align-items: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n	width: 24px;\n	margin-right: 16px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n	max-width: 700px;\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n    width: 224px;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n	width: 159px;\n	",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n		width: fit-content;\n	"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n	",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import PropTypes from "prop-types";
import { media, visibility } from "~/styles/mixins";
import { CTARow, ImageBlock, Image640x560, LogoBlock, MultipleSrcPicture, ResponsiveText, Signup, Header } from "~/components/Marketing";
import { Translation, useTranslation } from "~/components/Translation";
import Button from "~/components/Button";
import LinkBody from "~/components/LinkBodyV2";
import Pen from "~/components/CustomIcons/Marketing/WritingPen";
import Pulse from "~/components/CustomIcons/Marketing/Pulse";
import Heart from "~/components/CustomIcons/Marketing/Heart";
import Award from "~/components/CustomIcons/Marketing/Award";
import Key from "~/components/CustomIcons/Marketing/Key";
import Bookmark from "~/components/CustomIcons/Marketing/Bookmark";
import Star from "~/components/CustomIcons/Marketing/Star";
import Sun from "~/components/CustomIcons/Marketing/Sun";
import ThumbsUp from "~/components/CustomIcons/Marketing/ThumbsUp";
import People from "~/components/CustomIcons/Marketing/People";
import Palette from "~/components/CustomIcons/Marketing/Palette";
import Multistreaming from "~/components/CustomIcons/Marketing/Multistreaming";
import CameraPink from "~/components/CustomIcons/Marketing/Camera";
import HeartComment from "~/components/CustomIcons/Marketing/HeartComment";
import AddGuest from "~/components/CustomIcons/Marketing/AddGuest";
import analytics from "~/services/analytics";
import usePageTrack from "~/services/analytics/usePageTrack";
import { userSelectors } from "~/services/user";
import DigitialOceanPng from "~/static/images/brandLogos/digital-ocean.png";
import DigitialOceanWebp from "~/static/images/brandLogos/digital-ocean.webp";
import GoogleForStartupsPng from "~/static/images/brandLogos/google-for-startups.png";
import GoogleForStartupsWebp from "~/static/images/brandLogos/google-for-startups.webp";
import HootsuitePng from "~/static/images/brandLogos/hootsuite.png";
import HootsuiteWebp from "~/static/images/brandLogos/hootsuite.webp";
import MicrosoftPng from "~/static/images/brandLogos/microsoft.png";
import MicrosoftWebp from "~/static/images/brandLogos/microsoft.webp";
import MorningBrewPng from "~/static/images/brandLogos/morning-brew.png";
import MorningBrewWebp from "~/static/images/brandLogos/morning-brew.webp";
import SemRushPng from "~/static/images/brandLogos/semrush.png";
import SemRushWebp from "~/static/images/brandLogos/semrush.webp";
import TeachablePng from "~/static/images/brandLogos/teachable.png";
import TeachableWebp from "~/static/images/brandLogos/teachable.webp";
import WooCommercePng from "~/static/images/brandLogos/woo-commerce.png";
import WooCommerceWebp from "~/static/images/brandLogos/woo-commerce.webp";
import HeroImageSmallWebp from "./hero_image_small.webp";
import HeroImageSmallPng from "./hero_image_small.png";
import HeroImageLargeWebp from "./hero_image_large.webp";
import HeroImageLargePng from "./hero_image_large.png";
import BlockImageLiveVideoWebp from "./block_image_live_video.webp";
import BlockImageLiveVideoPng from "./block_image_live_video.png";
import StreamYardFeatureList from "./components/StreamYardFeatureList";
import StreamYardForCard from "./components/StreamYardForCard";
var HeroImageLarge = styled.div.withConfig({
    componentId: "sc-9a5b2244-0"
})(_templateObject(), visibility.showMedium);
var HeroImageLargeImage = styled(MultipleSrcPicture).withConfig({
    componentId: "sc-9a5b2244-1"
})(_templateObject1());
var HeroImageSmall = styled.div.withConfig({
    componentId: "sc-9a5b2244-2"
})(_templateObject3(), media.medium(_templateObject2()), visibility.hideMedium);
var HeroImageSmallImage = styled(MultipleSrcPicture).withConfig({
    componentId: "sc-9a5b2244-3"
})(_templateObject4());
var StyledBlockText = styled(ResponsiveText).withConfig({
    componentId: "sc-9a5b2244-4"
})(_templateObject6(), media.xLarge(_templateObject5()));
var IconFeatureWrap = styled.div.withConfig({
    componentId: "sc-9a5b2244-5"
})(_templateObject7());
var IconWrap = styled.div.withConfig({
    componentId: "sc-9a5b2244-6"
})(_templateObject8());
var CardWrap = styled.div.withConfig({
    componentId: "sc-9a5b2244-7"
})(_templateObject10(), media.medium(_templateObject9()));
var LogoImage = styled(MultipleSrcPicture).withConfig({
    componentId: "sc-9a5b2244-8"
})(_templateObject12(), media.large(_templateObject11()));
var StyledContactButton = styled(Button).withConfig({
    componentId: "sc-9a5b2244-9"
})(_templateObject14(), media.large(_templateObject13()));
var StreamYardForCards = function() {
    return /*#__PURE__*/ _jsxs(CardWrap, {
        children: [
            /*#__PURE__*/ _jsx(StreamYardForCard, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.brands.body"
                }),
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.brands"
                }),
                icon: /*#__PURE__*/ _jsx(Award, {})
            }),
            /*#__PURE__*/ _jsx(StreamYardForCard, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.influencers.body"
                }),
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.influencers"
                }),
                icon: /*#__PURE__*/ _jsx(Heart, {})
            }),
            /*#__PURE__*/ _jsx(StreamYardForCard, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.creators.body"
                }),
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.creators"
                }),
                icon: /*#__PURE__*/ _jsx(Pen, {
                    size: "24"
                })
            }),
            /*#__PURE__*/ _jsx(StreamYardForCard, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.leaders.body"
                }),
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.leaders"
                }),
                icon: /*#__PURE__*/ _jsx(Star, {})
            }),
            /*#__PURE__*/ _jsx(StreamYardForCard, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.media.body"
                }),
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.media"
                }),
                icon: /*#__PURE__*/ _jsx(ThumbsUp, {})
            }),
            /*#__PURE__*/ _jsx(StreamYardForCard, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.marketers.body"
                }),
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.marketers"
                }),
                icon: /*#__PURE__*/ _jsx(Pulse, {})
            }),
            /*#__PURE__*/ _jsx(StreamYardForCard, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.entrepreneurs.body"
                }),
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.entrepreneurs"
                }),
                icon: /*#__PURE__*/ _jsx(Key, {})
            }),
            /*#__PURE__*/ _jsx(StreamYardForCard, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.politicians.body"
                }),
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.politicians"
                }),
                icon: /*#__PURE__*/ _jsx(Bookmark, {})
            }),
            /*#__PURE__*/ _jsx(StreamYardForCard, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.churches.body"
                }),
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.churches"
                }),
                icon: /*#__PURE__*/ _jsx(Sun, {})
            }),
            /*#__PURE__*/ _jsx(StreamYardForCard, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.peopleTeams.body"
                }),
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.card.streamyardFor.peopleTeams"
                }),
                icon: /*#__PURE__*/ _jsx(People, {})
            })
        ]
    });
};
var WhyStreamYard = function(param) {
    var isAuth = param.isAuth;
    usePageTrack({
        name: analytics.events.WHY_STREAMYARD,
        category: analytics.events.category.MARKETING
    });
    return /*#__PURE__*/ _jsxs("main", {
        role: "main",
        children: [
            /*#__PURE__*/ _jsx(Header, {
                title: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.title"
                }),
                subtitles: [
                    /*#__PURE__*/ _jsx(Translation, {
                        tid: "landingWhyStreamYard.subtitle"
                    }, "1"), 
                ],
                cta: /*#__PURE__*/ _jsx(Signup, {})
            }),
            /*#__PURE__*/ _jsx(HeroImageLarge, {
                children: /*#__PURE__*/ _jsx(HeroImageLargeImage, {
                    webpSrc: HeroImageLargeWebp,
                    fallbackSrc: HeroImageLargePng,
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsx(HeroImageSmall, {
                children: /*#__PURE__*/ _jsx(HeroImageSmallImage, {
                    webpSrc: HeroImageSmallWebp,
                    fallbackSrc: HeroImageSmallPng,
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsx(ImageBlock, {
                body: useTranslation("landingWhyStreamYard.block.preferLiveVideo.body.one"),
                bodyTwo: useTranslation("landingWhyStreamYard.block.preferLiveVideo.body.two"),
                header: useTranslation("landingWhyStreamYard.block.preferLiveVideo.header"),
                image: /*#__PURE__*/ _jsx(Image640x560, {
                    webpSrc: BlockImageLiveVideoWebp,
                    fallbackSrc: BlockImageLiveVideoPng,
                    alt: ""
                }),
                reverse: true
            }),
            /*#__PURE__*/ _jsx(ImageBlock, {
                color: "slate",
                image: /*#__PURE__*/ _jsx(StreamYardFeatureList, {}),
                children: /*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(StyledBlockText, {
                            variant: "h2",
                            children: /*#__PURE__*/ _jsx(Translation, {
                                tid: "landingWhyStreamYard.block.certainFeatures.header"
                            })
                        }),
                        /*#__PURE__*/ _jsx(StyledBlockText, {
                            variant: "body",
                            children: /*#__PURE__*/ _jsx(Translation, {
                                tid: "landingWhyStreamYard.block.certainFeatures.subHeader"
                            })
                        }),
                        /*#__PURE__*/ _jsxs(IconFeatureWrap, {
                            children: [
                                /*#__PURE__*/ _jsx(IconWrap, {
                                    children: /*#__PURE__*/ _jsx(CameraPink, {})
                                }),
                                /*#__PURE__*/ _jsx(ResponsiveText, {
                                    variant: "body",
                                    children: /*#__PURE__*/ _jsx(Translation, {
                                        tid: "landingWhyStreamYard.block.certainFeatures.easyProduction"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(IconFeatureWrap, {
                            children: [
                                /*#__PURE__*/ _jsx(IconWrap, {
                                    children: /*#__PURE__*/ _jsx(Multistreaming, {
                                        size: "24",
                                        stroke: 3,
                                        fill: "#FFCC34"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(ResponsiveText, {
                                    variant: "body",
                                    children: /*#__PURE__*/ _jsx(Translation, {
                                        tid: "landingWhyStreamYard.block.certainFeatures.multistreaming"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(IconFeatureWrap, {
                            children: [
                                /*#__PURE__*/ _jsx(IconWrap, {
                                    children: /*#__PURE__*/ _jsx(AddGuest, {})
                                }),
                                /*#__PURE__*/ _jsx(ResponsiveText, {
                                    variant: "body",
                                    children: /*#__PURE__*/ _jsx(Translation, {
                                        tid: "landingWhyStreamYard.block.certainFeatures.guestsAndTeams"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(IconFeatureWrap, {
                            children: [
                                /*#__PURE__*/ _jsx(IconWrap, {
                                    children: /*#__PURE__*/ _jsx(Palette, {})
                                }),
                                /*#__PURE__*/ _jsx(ResponsiveText, {
                                    variant: "body",
                                    children: /*#__PURE__*/ _jsx(Translation, {
                                        tid: "landingWhyStreamYard.block.certainFeatures.onBrand"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(IconFeatureWrap, {
                            children: [
                                /*#__PURE__*/ _jsx(IconWrap, {
                                    children: /*#__PURE__*/ _jsx(HeartComment, {})
                                }),
                                /*#__PURE__*/ _jsx(ResponsiveText, {
                                    variant: "body",
                                    children: /*#__PURE__*/ _jsx(Translation, {
                                        tid: "landingWhyStreamYard.block.certainFeatures.interaction"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(ImageBlock, {
                image: /*#__PURE__*/ _jsx(StreamYardForCards, {}),
                children: [
                    /*#__PURE__*/ _jsx(StyledBlockText, {
                        variant: "h2",
                        children: /*#__PURE__*/ _jsx(Translation, {
                            tid: "landingWhyStreamYard.block.whoIsStreamYardFor.header"
                        })
                    }),
                    /*#__PURE__*/ _jsx(StyledBlockText, {
                        variant: "body",
                        children: /*#__PURE__*/ _jsx(Translation, {
                            tid: "landingWhyStreamYard.block.whoIsStreamYardFor.body"
                        })
                    }),
                    !isAuth && /*#__PURE__*/ _jsx(StyledContactButton, {
                        to: "/signup",
                        children: /*#__PURE__*/ _jsx(Translation, {
                            tid: "landingWhyStreamYard.block.whoIsStreamYardFor.button"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(LogoBlock, {
                color: "white",
                header: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.logos.header"
                }),
                titleTag: "h2",
                children: [
                    /*#__PURE__*/ _jsx(LogoImage, {
                        webpSrc: MicrosoftWebp,
                        fallbackSrc: MicrosoftPng,
                        alt: "Microsoft"
                    }),
                    /*#__PURE__*/ _jsx(LogoImage, {
                        webpSrc: GoogleForStartupsWebp,
                        fallbackSrc: GoogleForStartupsPng,
                        alt: "Google for Startups"
                    }),
                    /*#__PURE__*/ _jsx(LogoImage, {
                        webpSrc: TeachableWebp,
                        fallbackSrc: TeachablePng,
                        alt: "Teachable"
                    }),
                    /*#__PURE__*/ _jsx(LogoImage, {
                        webpSrc: WooCommerceWebp,
                        fallbackSrc: WooCommercePng,
                        alt: "WooCommerce"
                    }),
                    /*#__PURE__*/ _jsx(LogoImage, {
                        webpSrc: DigitialOceanWebp,
                        fallbackSrc: DigitialOceanPng,
                        alt: "Digital Ocean"
                    }),
                    /*#__PURE__*/ _jsx(LogoImage, {
                        webpSrc: MorningBrewWebp,
                        fallbackSrc: MorningBrewPng,
                        alt: "Morning Brew"
                    }),
                    /*#__PURE__*/ _jsx(LogoImage, {
                        webpSrc: SemRushWebp,
                        fallbackSrc: SemRushPng,
                        alt: "SemRush"
                    }),
                    /*#__PURE__*/ _jsx(LogoImage, {
                        webpSrc: HootsuiteWebp,
                        fallbackSrc: HootsuitePng,
                        alt: "Hootsuite"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CTARow, {
                body: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.cta.body",
                    components: {
                        link: /*#__PURE__*/ _jsx(LinkBody, {
                            to: "/contact-sales",
                            color: "onPrimary"
                        })
                    }
                }),
                title: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.cta.title"
                }),
                subtitle: /*#__PURE__*/ _jsx(Translation, {
                    tid: "landingWhyStreamYard.cta.subtitle"
                }),
                cta: /*#__PURE__*/ _jsx(Signup, {})
            })
        ]
    });
};
WhyStreamYard.propTypes = {
    isAuth: PropTypes.bool,
    NextImage: PropTypes.elementType
};
var mapStateToProps = function(state) {
    return {
        isAuth: userSelectors.isAuth(state)
    };
};
export default connect(mapStateToProps)(WhyStreamYard);
